import React, { useState, useEffect, useContext } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import TheUserImg from "../../images/thimg.png";
import { FaStar, FaRegStar } from "react-icons/fa";
import Icon1 from "../../images/theraicon1.svg";
import Icon2 from "../../images/theraicon2.svg";
import Icon3 from "../../images/theraicon3.svg";
import Icon4 from "../../images/dollar.svg";
import Icon5 from "../../images/clock.svg";
import { IoCalendarClearOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { CgGenderFemale } from "react-icons/cg";
import TherapistSidebar from "../../inc/TherapistSidebar";
import { FaAlignLeft } from "react-icons/fa";
import ApiService from "../../../utility/services/ApiService";
import { AuthContext } from "../../../utility/services/AuthContext";
import Functions from "../../../utility/services/Functions";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ConstConfig from "../../../utility/configs/constConfig";
import ImageConfig from "../../../utility/configs/imageConfig";
import UserAvatar from "../../common/UserAvatar";

const TherapistAppointmentDetail = () => {
  // LOGICAL VARIABLES

  const { get_therapist_specific_booking_details } = ApiService();
  const { setLoading } = useContext(AuthContext);
  const {
    consoleService,
    formet_date,
    formet_time,
    scheduledTimeForTherapist,
    getStars,
    calculateAge,
  } = Functions();
  const location = useLocation();
  const { booking_id } = location.state ? location.state : {};

  const [filterHideShow, setfilterHideShow] = useState(false);

  // DATA VARIABLES

  const [details, setDetails] = useState({});
  const [patientDetails, setPatientDetails] = useState({});

  // USE EFFECTS

  useEffect(() => {
    fetch_initial_details();
  }, []);

  // FUNCTIONS

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  async function fetch_initial_details() {
    setLoading(true);
    try {
      const res = await get_therapist_specific_booking_details(booking_id);
      if (res.status === 1) {
        const data = res.data;
        setDetails(data);
        setPatientDetails({ ...data.patient_details });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      consoleService("Error in fetch_initial_details", err);
    }
  }

  return (
    <>
      <div className="breadHidePhone">
        <BannerSection
          banner={Banner}
          name={"Home"}
          title={"Appointment Detail"}
        />
      </div>
      {Object.keys(details).length ? (
        <section className="py-5 useraccount bg-light_dash detailsBox ">
          <div className="container">
            <div className="row">
              <div
                className={`col-xl-3 col-md-4 ${
                  filterHideShow ? "leftShow" : "leftHide"
                }`}
              >
                <TherapistSidebar />
              </div>

              <div className="col-xl-9 col-md-8 fulltabBox therapist_appointment_details_fulltabBox">
                <div className="filterBox">
                  <Link className="filterIcon" onClick={sideBarHide}>
                    <FaAlignLeft />
                  </Link>
                </div>
                <div className="flexUser">
                  <div className="userDetails userDetails2">
                    <UserAvatar
                      profileImage={patientDetails.profile_img}
                      firstName={patientDetails.first_name || patientDetails.name}
                      lastName={patientDetails.last_name}
                      size="xl"
                      className="img-fluid thimg"
                      alt={`${patientDetails.first_name} ${patientDetails.last_name} profile`}
                    />
                    <div className="rightflex">
                      <div className="d-flex align-items-center">
                        <img
                          src={Icon1}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <h2 style={{ color: "black" }}>
                          {`${patientDetails.first_name} ${patientDetails.last_name}`}
                        </h2>
                      </div>

                      <div className="d-flex align-items-center mb-3 mt-1">
                        <img
                          src={Icon3}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <p className="mb-0">
                          {formet_date(details.time)} |{" "}
                          {formet_time(details.time)}
                        </p>
                      </div>

                      <div className="d-flex align-items-center mb-3 mt-1">
                        <img
                          src={Icon4}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <p className="mb-0">{details.price}</p>
                      </div>

                      <div className="d-flex align-items-center mt-1">
                        <img
                          src={Icon5}
                          alt=""
                          className="img-fluid me-2 icc"
                        />
                        <p className="mb-0">
                          {" "}
                          {scheduledTimeForTherapist(
                            details.pricing,
                            details.pricing_id
                          )}
                        </p>
                      </div>
                      <div className="d-flex align-items-center mb-2 mt-3">
                        <p className="mb-0">
                          <IoCalendarClearOutline
                            className="icc"
                            color="#2d7e7c"
                            fontSize={22}
                          />
                          {`${calculateAge(patientDetails.dob)} years`}
                        </p>
                      </div>
                      <div className="d-flex align-items-center mb-3 mt-1">
                        <p className="mb-0">
                          <CgGenderFemale
                            className="icc"
                            color="#2d7e7c"
                            fontSize={22}
                          />
                          {`${patientDetails.gender}`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <section className="py-5 specbox">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <h2 className="mb-3">Patient Feedback</h2>
                        {details?.reviews?.length ? (
                          <React.Fragment>
                            <div className="stardet">
                              {getStars(
                                <FaStar />,
                                <FaRegStar />,
                                Math.round(details?.reviews?.[0]?.rating || 0)
                              )}

                              <span>
                                {Math.round(details?.reviews?.[0]?.rating || 0)}
                              </span>
                            </div>
                            <p>{details?.reviews?.[0]?.reviews || ''}</p>
                          </React.Fragment>
                        ) : (
                          <>No Feedback found</>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
};

export default TherapistAppointmentDetail;
